export default __webpack_public_path__ + "static/media/101.fdf7b657.png";